import * as Sentry from '@sentry/browser';

export default function (userContext) {
  Sentry.configureScope((scope) => {
    scope.setUser(userContext);
  });
}
